const DISABLED_REASON = "recaptcha_enterprise_cost_guardrail";

let readiness = {
  mode: "off",
  status: "disabled",
  configured: false,
  tokenAvailable: false,
  errorCode: DISABLED_REASON,
};

const updateReadiness = (patch = {}) => {
  readiness = {
    mode: "off",
    status: "disabled",
    configured: false,
    tokenAvailable: false,
    errorCode: DISABLED_REASON,
    ...patch,
  };
  return readiness;
};

export const initializeFirebaseAppCheck = () => {
  updateReadiness();
  return null;
};

export const getFirebaseAppCheckToken = async () => {
  updateReadiness();
  return {
    token: null,
    ...readiness,
  };
};

export const getFirebaseAppCheckReadiness = () => ({ ...readiness });

export const _private = {
  DISABLED_REASON,
  resetForTests: () => {
    updateReadiness();
  },
};
